/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

export type ProductBulkAction = typeof ProductBulkAction[keyof typeof ProductBulkAction];


export const ProductBulkAction = {
  reconcile_asset_downloads: 'reconcile_asset_downloads',
  reconcile_transcoding: 'reconcile_transcoding',
  reconcile_asset_publish: 'reconcile_asset_publish',
  requeue_import: 'requeue_import',
} as const;
